import { connect } from 'react-redux';
import { EOtherCommunications } from '../../../../types/filters';
import { changeOtherCommunicationFilter } from '../../../../store/filters/actions';
import { createExtraFilter, IExtraFilterProps } from '../helpers';
import { mapDispatchToPropsCreator, mapStateToPropsCreator } from '../creators';
import { OTHER_COMMUNICATIONS } from '../../../../constants/filters';

export const OtherCommunicationLongNames: { [key: string]: string } = {
  drainage: 'С канализацией',
  electricity: 'С электричеством',
  gas: 'С газом',
  water: 'С водоснабжением',
};

const OtherCommunicationFilter = createExtraFilter<EOtherCommunications>(OTHER_COMMUNICATIONS);

type TOtherCommunicationFilterProps = IExtraFilterProps<EOtherCommunications>;

export const OtherCommunicationFilterContainer = connect<
  Pick<TOtherCommunicationFilterProps, 'selected'>,
  Pick<TOtherCommunicationFilterProps, 'toggle'>
>(
  mapStateToPropsCreator<EOtherCommunications>('otherCommunications'),
  mapDispatchToPropsCreator<EOtherCommunications>(changeOtherCommunicationFilter),
)(OtherCommunicationFilter);
